import countries from "countries-list";

export const countryNames = Object.values(countries.countries);
